import React, { useState } from "react";

const ProfileSelection = ({ profiles, onProfileSelect, onBack }) => {
    const [selectedProfile, setSelectedProfile] = useState(null);

    const handleProfileClick = (profile) => {
        setSelectedProfile(profile);
    };

    const handleLinkProfile = () => {
        if (selectedProfile) {
            onProfileSelect(selectedProfile);
        }
    };

    const buttonStyle = {
        minWidth: 140,
        padding: "8px 16px",
        borderRadius: 6,
        border: "1px solid #2346a0",
        background: "#fff",
        color: "#2346a0",
        fontWeight: 600,
        marginRight: 8,
        cursor: "pointer"
    };

    const primaryButtonStyle = {
        ...buttonStyle,
        background: "#2346a0",
        color: "#fff"
    };

    const profileCardStyle = {
        border: "2px solid #e0e0e0",
        borderRadius: 12,
        padding: 20,
        margin: "12px 0",
        backgroundColor: "#fff",
        cursor: "pointer",
        transition: "all 0.3s ease",
        position: "relative"
    };

    const selectedCardStyle = {
        ...profileCardStyle,
        border: "2px solid #2346a0",
        backgroundColor: "#f8f9ff"
    };

    return (
        <div className="abha-modal-overlay">
            <div className="abha-modal" style={{ maxWidth: 600 }}>
                <div className="abha-modal-header">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <h3 style={{ textAlign: "left", color: "#2346a0", marginBottom: 0 }}>Select Profile</h3>
                        {/* <img 
                            src={require("../../assets/images/NHIlogo.png")} 
                            alt="National Health Authority" 
                            style={{ height: 40 }} 
                        /> */}
                    </div>
                    <p style={{ color: "#666", fontSize: 14, marginTop: 8, marginBottom: 0 }}>
                        Choose the profile you want to link
                    </p>
                </div>

                <div className="abha-modal-body" style={{ maxHeight: 400, overflowY: "auto" }}>
                    {profiles && profiles.length > 0 ? (
                        profiles.map((profile, index) => (
                            <div
                                key={index}
                                style={selectedProfile?.ABHANumber === profile.ABHANumber ? selectedCardStyle : profileCardStyle}
                                onClick={() => handleProfileClick(profile)}
                            >
                                {/* Selection indicator */}
                                {selectedProfile?.ABHANumber === profile.ABHANumber && (
                                    <div style={{
                                        position: "absolute",
                                        top: 10,
                                        right: 10,
                                        width: 20,
                                        height: 20,
                                        backgroundColor: "#2346a0",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <span style={{ color: "white", fontSize: 12 }}>✓</span>
                                    </div>
                                )}

                                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                                    {/* Profile Photo */}
                                    <div style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        backgroundColor: "#f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden"
                                    }}>
                                        {profile.profilePhoto ? (
                                            <img
                                                src={`data:image/jpeg;base64,${profile.profilePhoto}`}
                                                alt="Profile"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover"
                                                }}
                                                onError={(e) => {
                                                    e.target.style.display = "none";
                                                    e.target.nextSibling.style.display = "flex";
                                                }}
                                            />
                                        ) : null}
                                        <div style={{
                                            width: "100%",
                                            height: "100%",
                                            display: profile.profilePhoto ? "none" : "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#e0e0e0",
                                            color: "#666",
                                            fontSize: 24
                                        }}>
                                            {profile.name ? profile.name.charAt(0).toUpperCase() : "?"}
                                        </div>
                                    </div>

                                    {/* Profile Details */}
                                    <div style={{ flex: 1 }}>
                                        <h4 style={{ 
                                            margin: "0 0 8px 0", 
                                            color: "#333", 
                                            fontSize: 18,
                                            fontWeight: 600 
                                        }}>
                                            {profile.name || "Unknown User"}
                                        </h4>
                                        
                                        <p style={{ 
                                            margin: "4px 0", 
                                            color: "#666", 
                                            fontSize: 14 
                                        }}>
                                            {profile.preferredAbhaAddress || "No ABHA Address"}
                                        </p>

                                        <div style={{ 
                                            marginTop: 8,
                                            fontSize: 14,
                                            color: "#333"
                                        }}>
                                            <strong>ABHA Number</strong>
                                            <br />
                                            <span style={{ color: "#2346a0", fontWeight: 600 }}>
                                                {profile.ABHANumber || "Not Available"}
                                            </span>
                                        </div>

                                        {/* Status indicators */}
                                        <div style={{ 
                                            marginTop: 8, 
                                            display: "flex", 
                                            gap: 12,
                                            alignItems: "center"
                                        }}>
                                            <span style={{
                                                padding: "2px 8px",
                                                borderRadius: 12,
                                                fontSize: 12,
                                                fontWeight: 500,
                                                backgroundColor: profile.status === "ACTIVE" ? "#e8f5e8" : "#fff3cd",
                                                color: profile.status === "ACTIVE" ? "#2e7d2e" : "#856404"
                                            }}>
                                                {profile.status || "Unknown"}
                                            </span>
                                            
                                            {profile.mobileVerified !== undefined && (
                                                <span style={{
                                                    padding: "2px 8px",
                                                    borderRadius: 12,
                                                    fontSize: 12,
                                                    fontWeight: 500,
                                                    backgroundColor: profile.mobileVerified ? "#e8f5e8" : "#ffe6e6",
                                                    color: profile.mobileVerified ? "#2e7d2e" : "#d63384"
                                                }}>
                                                    Mobile {profile.mobileVerified ? "Verified" : "Not Verified"}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ 
                            textAlign: "center", 
                            padding: 40, 
                            color: "#666" 
                        }}>
                            <p>No profiles found</p>
                        </div>
                    )}
                </div>

                <div className="abha-modal-actions" style={{ 
                    marginTop: 16, 
                    display: "flex", 
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <button 
                        style={buttonStyle}
                        onClick={onBack}
                    >
                        Back
                    </button>
                    
                    <button 
                        style={selectedProfile ? primaryButtonStyle : { ...buttonStyle, opacity: 0.5, cursor: "not-allowed" }}
                        onClick={handleLinkProfile}
                        disabled={!selectedProfile}
                    >
                        Link Profile
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfileSelection;
